import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsSavedViewsRoute: InvariantJiraRoute = {
	name: 'plan-settings-saved-views',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views',
};
